<template>
  <v-card>
    <v-form @submit.prevent="submitAdjustmentForm()" ref="adjustmentForm">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <span class="mr-2">
              <v-icon
                :color="$store.state.global.pages[$route.name].color"
              >{{$store.state.global.pages[$route.name].icon}}</v-icon>
            </span>
            <span class="headline">
              Add Adjustment for {{subject.name}}
              <span class="grey--text subheading">
                -
                <span class="font-weight-bold">{{project.name}}</span>
              </span>
            </span>
          </v-flex>
          <card-divider-header></card-divider-header>

          <v-flex xs12>
            <v-alert :value="true" type="info" class="mb-3" outline style="border-radius: 4px;">
              The adjustment will be automatically picked up and added as a line to the very next {{adjustment}} for
              <span
                class="font-weight-bold"
              >{{subject.name}} / {{project.name}}</span>
            </v-alert>
          </v-flex>
          <v-flex xs12>
            <v-radio-group v-model="adjustmentData.type" row>
              <v-radio label="Credit" value="credit" color="primary"></v-radio>
              <v-radio label="Debit" value="debit" color="red"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              :rules="amountRules"
              label="* Total Amount"
              :prepend-icon="adjustmentData.type == 'debit' ? 'remove' : 'add'"
              v-model.number="adjustmentData.total"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              :rules="notesRules"
              label="* Adjustment Notes"
              prepend-icon="note"
              v-model="adjustmentData.notes"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="close()" :color="primaryGrey">Close</v-btn>
        <v-btn flat type="submit" color="green darken-1" :loading="loading">Create</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Api from "@/services/api.js";
import AdjustmentRules from "@/services/validation/adjustmentValidation";
export default {
  mixins: [AdjustmentRules],
  data() {
    return {
      adjustmentData: {
        type: "debit",
        total: null,
        notes: ""
      },
      loading: false
    };
  },
  methods: {
    submitAdjustmentForm() {
      if (!this.$refs.adjustmentForm.validate()) return;
      this.loading = true;
      var body = this.adjustmentData;
      body.adjustment = this.$route.name;
      body.subjectId = this.subject.id;
      body.projectId = this.project.id;
      Api.post("rctis/adjustment", body)
        .then(result => {
          console.log(result.data.result);

          this.snack({ text: "Adjustment was added!", color: "green" });
          this.resetForm();
          this.close();
          this.loading = false;
        })
        .catch(err => {
          this.snack({ text: err.response.data.message, color: "red" });
          console.log(err);
          this.loading = false;
        });
    },
    close() {
      this.$emit("close");
    },
    resetForm() {
      this.adjustmentData.total = null;
      this.adjustmentData.notes = "";
    }
  },
  computed: {
    adjustment() {
      if (this.$route.name == "rcti") return "RCTI";
      return "Bill";
    }
  },
  props: {
    subject: Object,
    project: Object
  }
};
</script>

<style>
</style>
